import * as React from "react";

const Button = React.forwardRef(
  (
    { className = "", variant = "default", size = "default", ...props },
    ref
  ) => {
    // Pentatonic: pill-shaped buttons, 200ms ease-out transitions
    const baseStyles =
      "inline-flex items-center justify-center rounded-full font-mono text-sm uppercase tracking-wide transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-penta-mint focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

    const variants = {
      // Pentatonic Primary: mint bg, black text
      default: "bg-penta-mint text-penta-black hover:opacity-90",
      // Pentatonic Secondary: hollow/outline
      outline:
        "border border-penta-black bg-transparent text-penta-black hover:bg-penta-black hover:text-penta-white",
      // Ghost for subtle actions
      ghost: "text-penta-black hover:bg-penta-black/5",
      // Destructive uses coral
      destructive: "bg-penta-coral text-penta-white hover:opacity-90",
      secondary:
        "bg-penta-grey-light text-penta-black border border-penta-black/10 hover:border-penta-black/30",
      link: "text-penta-blue underline-offset-4 hover:underline",
      success: "bg-penta-mint text-penta-black hover:opacity-90",
    };

    const sizes = {
      default: "h-10 px-6 py-2",
      sm: "h-8 px-4 py-2 text-xs",
      lg: "h-12 px-8",
      icon: "h-10 w-10",
    };

    const classes = [baseStyles, variants[variant], sizes[size], className]
      .filter(Boolean)
      .join(" ");

    return <button className={classes} ref={ref} {...props} />;
  }
);
Button.displayName = "Button";

export { Button };
